export { default } from "./SortableDeckOfCards.jsx";
